import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import DataTable from '../components/DataTable';

const VADE_STIL = {
  GECMIS: { bg:'#ffebee', color:'#b71c1c', label:'⛔ SÜRESI GEÇMİŞ' },
  KRITIK: { bg:'#fff3e0', color:'#e65100', label:'🔴 KRİTİK (≤30 gün)' },
  YAKIN:  { bg:'#fffde7', color:'#f57f17', label:'🟡 YAKLAŞIYOR (≤60 gün)' },
  ORTA:   { bg:'#e8f5e9', color:'#2e7d32', label:'🟢 ORTA (≤90 gün)' },
};

export default function VadesiYaklasan() {
  const navigate = useNavigate();
  const [veriler, setVeriler] = useState({ yaklasan: [], gecmis: [] });
  const [yukleniyor, setYukleniyor] = useState(true);
  const [filtre, setFiltre] = useState('KRITIK');
  const [gun, setGun] = useState(90);

  useEffect(() => { yukle(); }, [gun]); // eslint-disable-line

  const yukle = async () => {
    setYukleniyor(true);
    try {
      const r = await api.get(`/raporlar/vadesi-yaklasan?gun=${gun}`);
      setVeriler(r.data);
    } catch { } finally { setYukleniyor(false); }
  };

  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '—';

  const tumVeriler = filtre === 'GECMIS'
    ? veriler.gecmis
    : veriler.yaklasan.filter(v => {
        if (filtre === 'KRITIK') return v.vade_durumu === 'KRITIK';
        if (filtre === 'YAKIN') return ['KRITIK','YAKIN'].includes(v.vade_durumu);
        return true;
      });

  const columns = [
    { key:'rn', label:'Ruhsat No', width:'110px', render:v=><strong style={{fontFamily:'monospace',color:'#1a237e'}}>{v}</strong> },
    { key:'unvan', label:'İşyeri Ünvanı', render:v=><span style={{fontSize:'12px',fontWeight:'600'}}>{v}</span> },
    { key:'isyeri_adresi', label:'Adres', render:v=><span style={{fontSize:'11px',color:'#666'}}>{v||'—'}</span> },
    { key:'ruhsat_bitis_tarihi', label:'Bitiş Tarihi', width:'110px', render:v=><span style={{fontSize:'13px',fontWeight:'700'}}>{fmt(v)}</span>, exportValue:r=>fmt(r.ruhsat_bitis_tarihi) },
    { key:'kalan_gun', label:'Kalan Gün', width:'90px', render:(v,r)=>{
      const gun = parseInt(v||0);
      const stil = VADE_STIL[r.vade_durumu] || VADE_STIL.ORTA;
      return <span style={{background:stil.bg,color:stil.color,padding:'2px 8px',borderRadius:'10px',fontWeight:'700',fontSize:'12px'}}>
        {r.vade_durumu==='GECMIS' ? `${Math.abs(gun)} gün önce` : `${gun} gün`}
      </span>;
    }, exportValue:r=>r.kalan_gun },
    { key:'vade_durumu', label:'Durum', width:'80px', render:(v)=>{
      const s = VADE_STIL[v];
      return <span style={{color:s?.color,fontSize:'11px',fontWeight:'700'}}>{s?.label||v}</span>;
    }, exportValue:r=>r.vade_durumu },
    { key:'_islem', label:'İşlem', width:'80px', sortable:false, filterable:false,
      render:(_,r)=><button className="btn btn-secondary btn-xs" onClick={e=>{e.stopPropagation();navigate(`/ruhsat/${r.id}`);}}>Detay</button>
    },
  ];

  const istatistik = {
    gecmis: veriler.gecmis.length,
    kritik: veriler.yaklasan.filter(v=>v.vade_durumu==='KRITIK').length,
    yakin: veriler.yaklasan.filter(v=>v.vade_durumu==='YAKIN').length,
    orta: veriler.yaklasan.filter(v=>v.vade_durumu==='ORTA').length,
  };

  return (
    <div>
      <div style={{marginBottom:'20px'}}>
        <h2 style={{color:'#1a237e',fontSize:'20px'}}>⏰ Vadesi Yaklaşan / Geçen Ruhsatlar</h2>
        <div style={{fontSize:'12px',color:'#888',marginTop:'2px'}}>Dayanak: İşyeri Ruhsat Yönetmeliği Md.18 — Yıllık yenileme zorunluluğu</div>
      </div>

      {/* İstatistik kartları */}
      <div className="stats-grid" style={{gridTemplateColumns:'repeat(4,1fr)'}}>
        {[
          { k:'GECMIS', label:'Süresi Geçmiş', sayi:istatistik.gecmis, stil:{background:'linear-gradient(135deg,#b71c1c,#e53935)'} },
          { k:'KRITIK', label:'Kritik (≤30 gün)', sayi:istatistik.kritik, stil:{background:'linear-gradient(135deg,#e65100,#ff7043)'} },
          { k:'YAKIN', label:'Yaklaşıyor (≤60 gün)', sayi:istatistik.yakin, stil:{background:'linear-gradient(135deg,#f57f17,#ffb300)'} },
          { k:'ORTA', label:'Orta (≤90 gün)', sayi:istatistik.orta, stil:{background:'linear-gradient(135deg,#2e7d32,#43a047)'} },
        ].map(c=>(
          <div key={c.k} className="stat-card" style={{...c.stil,color:'#fff',border:'none',cursor:'pointer',transform:filtre===c.k?'scale(1.03)':'scale(1)',transition:'transform 0.15s'}}
            onClick={()=>setFiltre(c.k)}>
            <div className="stat-info">
              <h3 style={{color:'#fff',fontSize:'28px'}}>{c.sayi}</h3>
              <p style={{color:'rgba(255,255,255,0.85)'}}>{c.label}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="card">
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px',flexWrap:'wrap',gap:'8px'}}>
          <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
            {Object.entries(VADE_STIL).map(([k,s])=>(
              <button key={k} className={`btn btn-sm ${filtre===k?'btn-primary':'btn-outline'}`} onClick={()=>setFiltre(k)}>
                {s.label}
              </button>
            ))}
          </div>
          <div style={{display:'flex',gap:'8px',alignItems:'center',fontSize:'13px'}}>
            <span>Dönem:</span>
            {[30,60,90].map(g=>(
              <button key={g} className={`btn btn-sm ${gun===g?'btn-primary':'btn-outline'}`} onClick={()=>setGun(g)}>{g} gün</button>
            ))}
          </div>
        </div>
        <div style={{marginBottom:'8px',fontSize:'12px',color:'#666'}}><strong>{tumVeriler.length}</strong> kayıt listeleniyor</div>
        <DataTable columns={columns} data={tumVeriler} filename="vadesi_yaklasan" pdfTitle="Vadesi Yaklaşan Ruhsatlar" loading={yukleniyor} />
      </div>
    </div>
  );
}
